import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import AuthShell from "./AuthShell";
import { completeLoginWithToken } from "./authUtils";

/**
 * Handles SSO return via query string (?token= or ?error=).
 * Phase 1: API may redirect to FabPro directly; this covers login-page handoffs.
 */
export default function SsoCallback({ queryAuth, onError }) {
  const [status, setStatus] = useState("processing");

  useEffect(() => {
    const token = queryAuth?.token;
    const error = queryAuth?.error;

    if (error) {
      let message;
      try {
        message = decodeURIComponent(error.replace(/\+/g, " "));
      } catch {
        message = error;
      }
      onError(message);
      return;
    }

    if (token) {
      setStatus("redirecting");
      completeLoginWithToken(token.replace(/"/g, "")).catch(() => {
        onError("Sign-in could not be completed. Please try again.");
      });
      return;
    }

    onError("Sign-in could not be completed. Please try again.");
  }, [queryAuth, onError]);

  return (
    <AuthShell title="Signing you in">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        py={4}
        gap={2}
      >
        <CircularProgress size={36} color="primary" />
        <Typography color="text.secondary" variant="body2">
          {status === "redirecting"
            ? "Redirecting to MSUITE…"
            : "Completing sign-in…"}
        </Typography>
      </Box>
    </AuthShell>
  );
}
